<template>
    <div class="Welcome">
        <div class="container">
            <div vs-type="flex" vs-justify="center" vs-align="center">
                <div>
                    <h3 style="font-weight: bolder">
                        Welcome to English Language Test by Skill Lab!
                    </h3>
                    <br />
                    <p>
                        This is an English Audio Transcription Test. It is an efficient tool to
                        improve your English through transcribing.
                    </p>
                    <br />
                    <h5 style="font-weight: bolder">The test will judge:</h5>
                    <ol class="list-style">
                        <li>How well you can listen and understand English audio clips.</li>
                        <li>Your ability to type what you hear word for word.</li>
                        <li>Your knowledge of Basic English and grammar.</li>
                    </ol>
                    <br />
                    <h6 style="font-weight: bolder">The test will help you improve:</h6>
                    <ol class="list-style">
                        <li>Your listening skills</li>
                        <li>Your typing and transcribing skills.</li>
                        <li>Your English grammar and comprehension.</li>
                    </ol>
                    <br />
                    <p>
                        The Practice Test enables you get used to the way of English transcription
                        test and to improve your performance in the actual test.
                    </p>
                </div>
                <hr />
                <div vs-type="flex" vs-justify="space-around">
                    <b-button
                        type="button"
                        class="sbutton-imp p-2 m-2"
                        @click="takeTest"
                        variant="info"
                    >
                        <span class="button-header">Start Test</span>
                    </b-button>
                    <b-button
                        type="button"
                        class="sbutton-imp p-2 m-2"
                        @click="takePracticeTest"
                        variant="success"
                    >
                        <span class="button-header">Start Practice Test</span>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
    name: 'Welcome',
    methods: {
        takeTest() {
            this.$store.state.Test.PracticeTest = false;
            this.$router.push({ name: 'Instructions' });
        },
        takePracticeTest() {
            this.$store.state.Test.PracticeTest = true;
            this.$router.push({ name: 'PracticeTest' });
        },
    },
};
</script>

<style>
.sbutton-imp {
    width: 200px;
}
.Welcome {
    width: 40%;
    margin: auto;
    text-align: left;
    /* border: 1px solid; */
}
.container {
    margin-top: 4%;
}
.list-style li {
    margin-left: 30px;
}
.card {
    width: 60%;
    background-color: transparent !important;
    color: #0b1c4b;
    margin-left: 20%;
}
.info {
    margin-left: 7%;
    text-align: start;
    font-size: 17px;
    margin-top: 4%;
    color: #0b1c4b;
}
.lists {
    margin-top: 5%;
    margin-left: 2%;
}
.card-header {
    font-size: 28px;
}
.button-header {
    font-size: 20px;
}

/* p {
    ;
} */
</style>
